export default __webpack_public_path__ + "static/media/TextEditor.79967c33.png";